<template>
  <div>
    <Header />
    <div class="content-web container mt-5">
      <!-- Filter -->
      <div class="col-12 search-box mb-5 clearfix" id="search">
        <div class="row">
          <div class="col-12">
            <label class="title">Bộ lọc:</label>
          </div>
        </div>

        <div class="row">
          <div class="col-12 d-flex mr-2 mb-2">
            <input
              v-model="searchForm.title"
              class="form-control mr-2 mb-2"
              type="text"
              placeholder="Tiêu đề"
              v-on:keyup.enter="searchSubmission(true)"
            />
            <v-select
              style="width: 200px;"
              class="mr-2"
              placeholder="Tháng"
              :options="listPeriod"
              :reduce="obj => obj.code"
              label="name"
              v-model="searchForm.period"
            ></v-select>
            <v-select
              style="width: 250px;"
              class="mr-2"
              placeholder="Thao tác chấm"
              :options="[{code: 'scored', name: 'Đã thao tác chấm'}, {code: 'notScored', name: 'Chưa thao tác chấm'}]"
              :reduce="obj => obj.code"
              label="name"
              v-model="searchForm.userScored"
            ></v-select>
            <div>
              <button class="btn btn_control mr-1 mb-2" v-on:click="searchSubmission(true)">Tìm kiếm</button>
              <button type="submit" class="btn btn_control mr-1 mb-2" v-on:click="clearSearch()">Xóa</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Loading -->
      <div class="table-box list-grid mb-5" v-if="loading">
        <div class="text-center">
          <div class="spinner-border text-dark" role="status">
            <span class="sr-only">Đang tải...</span>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div v-else class="table-box list-grid mb-5">
        <div class="title">
          <h6>DANH SÁCH KẾT QUẢ DỰ THI THÁNG</h6>
        </div>
        <div class="content-table">
          <table class="table table-hover table-md" style="overflow: inherit; table-layout: fixed;">
            <thead>
              <tr style=" text-align:top;">
                <th style="width: 60px;">ID</th>
                <th style="width: 180px;">TIÊU ĐỀ</th>
                <th style="width: 130px;">Chung khảo tháng</th>
                <th style="width: 100px;">Danh hiệu</th>
                <th style="width: 130px;">Lĩnh vực</th>
                <th style="width: 200px;">Giới thiệu ngắn gọn</th>
                <th style="width: 110px;">CTTV</th>
                <th style="width: 110px;">Tác giả</th>
                <th style="width: 110px;" v-show="showAction" >Thao tác</th>
              </tr>
            </thead>
            <tbody>
              <tr class="cell" v-for="item in submission" v-bind:key="item.id">
                <td>{{item.ideaId}}</td>
                <td style="word-break: break-word;">
                  <a v-bind:href="($cookies.get('roles') ? ipDetailUrl : ipUserDetailUrl ) + '/' + item.ideaId">{{item.ideaTitle}}</a>
                </td>
                <td>{{item.periodName}}</td>
                <td> <span v-if="checkRole">{{getMedalName(item)}}</span>
                     <span v-else></span>            
                </td>

                <!-- <td>{{getMedalName(item)}}</td> -->
                <td>{{item.typeName}}</td>
                <td>{{item.summary}}</td>
                <td>{{item.companyName}}</td>
                <td style="word-break: break-word;">{{item.author}}</td>
                <td v-show="showAction" >
                  <button @click="openModalScoring(item.ideaId)" class="btn btn-primary" >Chi tiết</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row mt-4 pagination">
          <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 pagesize">
            <span
              v-if="((pageSize*pageIndex)>total&&total!=0)"
            >{{pageSize*(pageIndex-1)+1}}-{{total}} của {{total}}</span>
            <span
              v-if="((pageSize*pageIndex)<=total)&&total!=0"
            >{{pageSize*(pageIndex-1)+1}}-{{pageSize*pageIndex}} của {{total}}</span>
            <span v-if="total==0">0-0 của 0</span>
          </div>
          <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 d-flex justify-content-end pageindex">
            <b-pagination
              v-if="total > pageSize"
              v-model="pageIndex"
              pills
              :total-rows="total"
              :per-page="pageSize"
            ></b-pagination>
          </div>
        </div>
      </div>
      <b-modal ref="scoringResultModal" hide-footer title="Kết quả chấm điểm" size="xl">
        <table class="table table-striped">
          <thead>
          <tr>
            <th>Người chấm</th>
            <th>Danh hiệu</th>
            <th>Thời gian chấm</th>
            <th>Nhận xét</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in listScoringResult" >
            <td>{{item.createdBy}}</td>
            <td>{{item.medal}}</td>
            <td>{{new Date(item.createdTime)}}</td>
            <td>{{item.comment}}</td>
          </tr>
          </tbody>
        </table>
        <div class="row">
          <div class="col-12">
            <div class="btn-group pull-right">
              <button class="btn btn-info" @click="closeScoringResultModal()">Đóng</button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import * as CONFIG from "../../config/index";
import moment from "moment";
import Vue from "vue";
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { BPagination } from "bootstrap-vue";

import MasterDataCommon from "../../common/masterData";
import IdeaCommon from "../../common/idea";
import CompanyCommon from "../../common/company";
import ideaPeriodCommon from "../../common/ideaPeriod";
import periodCommon from "../../common/period";
import helper from "../../common/helper";
import ideaScoring from '../../common/ideaScoring'
import ideaCommon from '../../common/idea'

const defaultSearchForm = {
  title: "",
  period: "",
  userScored: ""
};
export default {
  name: "IdeasContest",
  components: {
    Header,
    Footer,
    "b-pagination": BPagination,
    DatePicker
  },
  data() {
    return {
      ipDetailUrl: `${CONFIG.CLIENT_URL}/#/admin/ip-view`,
      ipUserDetailUrl: `${CONFIG.CLIENT_URL}/#/ip-view`,
      loading: false,
      searchForm: { ...defaultSearchForm },
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      listStatus: [],
      listType: [],
      submission: [],
      companys: [],
      listPeriod: [],
      listScoringResult: [],
      showAction: false,
      checkRole : false,
    };
  },
  filters: {
    date: function(date) {
      return moment(date).format("YYYY-MM-DD");
    }
  },
  methods: {
    async fetchData() {
      Promise.all([
        MasterDataCommon.sync.getByType("idea_status"),
        MasterDataCommon.sync.getByType("idea_type"),
        CompanyCommon.getAll()
      ]).then(res => {
        this.listStatus = res[0];
        this.listType = res[1];
        this.companys = res[2];
      });
    },
    clearSearch() {
      this.clearFilterSearch();
      this.searchSubmission(true);
    },
    clearFilterSearch() {
      this.searchForm = { ...defaultSearchForm };
    },

    async getRole(){
      if(Vue.$cookies.get("roles") !== null && Vue.$cookies.get("roles") !== undefined){
        let role = Vue.$cookies.get("roles");
        this.checkRole = role.includes("system_admin") || role.includes("chief_jury") ;  
      }      
    },

    async searchSubmission(isFirstPage) {
      this.loading = true;
      if (isFirstPage) {
        this.pageIndex = 1;
      }
      const res = await ideaPeriodCommon.search(
        this.searchForm.title,
        this.searchForm.period,
        this.searchForm.userScored,
        "scored",
        this.pageIndex,
        this.pageSize
      );
      this.submission = res.items;
      this.total = res.totals;
      this.loading = false;
    },
    getTypeName(code) {
      if (!code) {
        return "";
      }
      const typeData = this.listType.find(p => p.code === code);
      if (typeData) {
        return typeData.name;
      }
      return "";
    },
    getMedalName(idea) {
      try {
        if (!idea.finalMedal && !idea.yearReward) {
          return "";
        }

        if (idea.yearReward && (idea.yearReward == 1 || idea.yearReward == 2)) {
          return idea.yearReward == 1 ? "Sáng tạo của năm" : "Giải nhì năm";
        } else {
          return helper.getMedalName(idea.finalMedal);;
        }
      } catch (error) {
        return "";
      }
    },
    async openModalScoring(ideaId) {
      this.listScoringResult = await ideaScoring.getByIdeaId(ideaId);
      console.log(this.listScoringResult);
      this.$refs.scoringResultModal.show();
    },
    closeScoringResultModal() {
      this.$refs.scoringResultModal.hide();
    }
  },
  async created() {
    await this.getRole();
    await this.fetchData();
    await this.searchSubmission(true);
    const periodRes = await periodCommon.search("", 1, 1000);
    this.listPeriod = periodRes.items;
  },
  mounted() {
    this.showAction = helper.getUserRole()['coordinator'] && this.$cookies.get('globalRoles') === 'true' ;
  },
  watch: {
    pageIndex: {
      immediate: false,
      async handler(newVal, oldVal) {
        await this.searchSubmission(false);
      }
    }
  },
};
</script>

<style scoped>
@import "../../assets/css/filter_customs.css";
@import "../../assets/css/table_customs.css";
</style>




// WEBPACK FOOTER //
// src/components/pages/IdeasRecognition.vue